import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { hasActiveSubscription } from '../utils/subscriptionUtils';

const ProtectedRoute = ({ children, requiredSubscription = false }) => {
  const { user, userProfile, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/registration-login" replace />;
  }

  // Check subscription requirement if needed
  // Female users and demo accounts get free access
  if (requiredSubscription && !hasActiveSubscription(userProfile)) {
    return <Navigate to="/subscription-payment" replace />;
  }

  // User is authenticated (and has subscription if required)
  return children;
};

export default ProtectedRoute;
